/**
 * HostCta — 홈 → 호스트 신청 진입 섹션 (PartnershipProposal와 HomeFooter 사이).
 * 문구/링크는 copy.js(HOST)에서 가져옴. 하드코딩 0.
 */
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/HostCta.module.css';
import { HOST } from './copy';
import { HOST_SELF_ONBOARDING } from '../../config/featureFlags';

// /host/ 는 preact-router 라우트가 아니라 별도 정적 문서(멀티페이지 빌드).
// plain <a> 는 preact-router가 가로채 홈으로 튕기므로, 기본 동작을 막고 실제 문서로 하드 내비게이션한다.
function handleHostNavigate(e) {
  // 새 탭/수정키 클릭은 브라우저 기본 동작 유지.
  // (button 체크는 제거 — 모바일 터치 click에서 e.button이 undefined라 조기 return되어 튕기던 원인)
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  window.location.assign(HOST.ctaHref);
}

export default function HostCta() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  // HOST_SELF_ONBOARDING이 꺼져 있으면 홈에서 /host 진입점을 숨긴다.
  // (백엔드 host-applications API + 어드민 검토 준비 전까지 기본 OFF)
  if (!HOST_SELF_ONBOARDING) return null;

  return (
    <section id="host-cta" ref={ref} className={`section ${styles.hostCta} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.inner}>
        <h2 className={styles.headline}>{HOST.headline}</h2>
        <p className={styles.subcopy}>{HOST.subcopy}</p>
        <a
          href={HOST.ctaHref}
          className="btn btn-primary"
          onClick={handleHostNavigate}>
          {HOST.ctaLabel}
        </a>
      </div>
    </section>
  );
}
